import styled from "styled-components";
import { StyledCard } from "./interface";

export const ObjectivesContainer = styled.div`
    width: 100%;
    height: 100%;

`;

export const ObjectiveCard = styled.div<StyledCard>`
    background-color: rgba(255,255,255,0.2);
    min-height: 95px;
    display: grid;
    margin: 5px;
    padding: 5px;
    cursor: pointer;
    position: relative;
    border: ${(props) => props.emphasis ? "2px solid white" : "0px solid white" };
    border-radius: 5px;

    .btn-option{
        display: ${(props) => props.inEditCauseEffect ? "none" : "block" };
    }



    .connector-arrow{
        position: absolute;
        width: 6px;
        height: 6px;
        display: flex;
        align-self: center;
        justify-self: center;
    }

    &:hover{
        .card-options-objectives{
            display: flex;
        }
    }

    .card-options-objectives{
        display: none;
        flex-wrap: wrap;
        position: absolute;
        top: -16px;
        right: 4px;
        z-index: 1;

        button{
            background-color: ${(props) => props.color };
            border: 1px solid white;
        }

        span._component_tooltip-span{
            background-color: ${(props) => props.color };
            border: 1px solid white;
        }
    }

    .card-header{
        height: 30%;
        
        span{
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    } 

    .card-body{
        height: 65%;
        display: flex;
        align-items: flex-end;
    }
`;

export const ObjectiveCardBasic = styled.div`
    background-color: rgba(255,255,255,0.2);
    min-height: 95px;
    display: grid;
    margin: 5px;
    padding: 5px;
    cursor: pointer;
    position: relative;
    border-radius: 5px;

    .connector-arrow{
        position: absolute;
        width: 6px;
        height: 6px;
        display: flex;
        align-self: center;
        justify-self: center;
    }

    &:hover{
        .card-options-objectives{
            display: flex;
        }
    }

    .card-options-objectives{
        display: none;
        flex-wrap: wrap;
        position: absolute;
        top: -16px;
        right: 4px;
        z-index: 1;

        button{
            border: 1px solid white;
        }

        span._component_tooltip-span{
            border: 1px solid white;
        }
    }

    .card-header{
        height: 30%;
        
        span{
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    } 

    .card-body{
        height: 65%;
        display: flex;
        align-items: flex-end;
    }
`;

export const CardNewObjective = styled.div`
    background-color: rgba(255,255,255,0.2);
    height: 100px;
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    margin: 5px;
    cursor: pointer;
    display: none;

    span{
        margin-left: 5px;
    }
`;

export default ObjectivesContainer;
